import React from 'react';
import { FormItemProps } from 'antd';
import { CustomFormItem } from '../Steps/Informations/Inputs/styles';

interface CustomFormItemProps {
	name?: string | string[];
	children: JSX.Element;
}

export function FormItem({
	name,
	label,
	children,
	required = false,
	...props
}: Readonly<CustomFormItemProps & FormItemProps>): JSX.Element {
	return (
		<CustomFormItem name={name} {...props}>
			{children}
		</CustomFormItem>
	);
}
